import { useContext } from 'react';
import { FingerprintContext } from '../../providers/FingerprintProvider/FingerprintContext';

export const useFingerprint = () => {
  const fingerprint = useContext(FingerprintContext);
  return fingerprint;
};
